import { render, staticRenderFns } from "./SidebarShows.vue?vue&type=template&id=412f908e&"
import script from "./SidebarShows.vue?vue&type=script&lang=js&"
export * from "./SidebarShows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports